
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_145pa_lqzvj_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_145pa_lqzvj_1",
  "root": "awsui_root_145pa_lqzvj_120",
  "date-picker-container": "awsui_date-picker-container_145pa_lqzvj_131",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_lqzvj_136",
  "date-picker-input": "awsui_date-picker-input_145pa_lqzvj_140",
  "open-calendar-button": "awsui_open-calendar-button_145pa_lqzvj_145",
  "calendar-inner": "awsui_calendar-inner_145pa_lqzvj_165",
  "calendar-header": "awsui_calendar-header_145pa_lqzvj_168",
  "calendar-header-month": "awsui_calendar-header-month_145pa_lqzvj_173",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_145pa_lqzvj_179",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_145pa_lqzvj_182",
  "calendar-day-names": "awsui_calendar-day-names_145pa_lqzvj_185",
  "calendar-day-name": "awsui_calendar-day-name_145pa_lqzvj_185",
  "calendar-dates": "awsui_calendar-dates_145pa_lqzvj_200",
  "calendar-week": "awsui_calendar-week_145pa_lqzvj_203",
  "calendar-day": "awsui_calendar-day_145pa_lqzvj_185",
  "calendar-day-in-last-week": "awsui_calendar-day-in-last-week_145pa_lqzvj_222",
  "calendar-day-focusable": "awsui_calendar-day-focusable_145pa_lqzvj_225",
  "calendar-day-enabled": "awsui_calendar-day-enabled_145pa_lqzvj_228",
  "calendar-day-current-month": "awsui_calendar-day-current-month_145pa_lqzvj_232",
  "calendar-day-selected": "awsui_calendar-day-selected_145pa_lqzvj_239",
  "calendar-day-today": "awsui_calendar-day-today_145pa_lqzvj_243",
  "day-inner": "awsui_day-inner_145pa_lqzvj_255"
};
  